import React from 'react';
import { useDialog } from '~/components/dialog/dialog';
import GiveBeforePdf from './give-before-pdf';
import GiveBeforeOther from './give-before-other';
import ContentWarning, { checkWarningCookie } from './content-warning';
import useDonationPopupData from './use-donation-popup-data';
import { isMobileDisplay } from '~/helpers/device';
export default function useGiveDialog() {
    const [Dialog, open, close] = useDialog();
    const data = useDonationPopupData();
    const GiveDialog = React.useCallback(({ link, track, onDownload, variant, warning = '', id }) => {
        const variantParams = { link, track, close, data, onDownload, variant, warning, id };
        const [Variant, typedVariantParams] = lookupVariant(warning, variantParams);
        const aria = Variant === GiveBeforePdf
            ? { labelledby: 'dialog-heading' }
            : { label: 'Before you go there' };
        return (React.createElement(Dialog, { aria: aria },
            React.createElement(Variant, Object.assign({}, typedVariantParams))));
    }, [close, data, Dialog]);
    return {
        GiveDialog,
        open,
        enabled: !(data === null || data === void 0 ? void 0 : data.hide_donation_popup)
    };
}
export function useOpenGiveDialog() {
    const { GiveDialog, open, enabled } = useGiveDialog();
    const openGiveDialog = React.useCallback((event) => {
        if (enabled && !isMobileDisplay()) {
            event.preventDefault();
            open();
        }
    }, [enabled, open]);
    return { GiveDialog, openGiveDialog };
}
// This was a little bit clever, so typing became a problem
function lookupVariant(warning, variantParams) {
    const { id, variant } = variantParams;
    if (warning && id && !checkWarningCookie(id)) {
        return [ContentWarning, variantParams];
    }
    if (variant !== undefined) {
        return [GiveBeforeOther, variantParams];
    }
    return [GiveBeforePdf, variantParams];
}
